import palette from './colors.json';

const fonts = {
  bold: 'Inter-Bold',
  medium: 'Inter-Medium',
  regular: 'Inter-Regular',
  semibold: 'Inter-Semibold',
};

const gradient = {
  startAxis: { x: 0.0, y: 0.5 },
  endAxis: { x: 0.5, y: 1.0 },
  location: [0, 0.8],
};

const radius = {
  s: 4,
  m: 8,
  l: 16,
};

const shadow = {
  light: {
    shadowColor: palette.black,
    shadowOpacity: 0.15,
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 6,
    elevation: 3,
  },
  strong: {
    shadowColor: palette.black,
    shadowOpacity: 0.3,
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 6,
    elevation: 6,
  },
};

const theme = {
  fonts,
  gradient,
  palette,
  radius,
  shadow,
};

export default theme;
